export default __webpack_public_path__ + "assets/hungary-flag.png";